import { Box, Skeleton } from "@chakra-ui/react";
import { formatInteger } from "utils/formatting";

export type Props = {
  isLoading?: boolean;
  resultTypeLabel?: string;
  totalCount: number | undefined | null;
};

export default function NumResultsLabel({
  isLoading = false,
  resultTypeLabel = "results",
  totalCount,
}: Props) {
  return (
    <Box color="gray" fontSize="xs" noOfLines={4}>
      <Skeleton isLoaded={!isLoading || !!totalCount} display="inline-block">
        <Box as="span">{formatInteger(totalCount) ?? "     "}</Box>
      </Skeleton>{" "}
      {resultTypeLabel} found
    </Box>
  );
}
